import { render, staticRenderFns } from "./UserLimits.vue?vue&type=template&id=28ddf7b8&scoped=true"
import script from "./UserLimits.vue?vue&type=script&lang=js"
export * from "./UserLimits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ddf7b8",
  null
  
)

export default component.exports